<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header/>
    <Scroll/>
    <div class="hp_productMain_contentWrap">
      <div class="hp_productMain_contentSidebar hp_reservationSidebar">
        <div class="hp_productMain_contentKeywordBox">
          <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
          <div class="hp_productMain_contentKeyword_tagBox">
            <p
                v-for="item in statusData.hotKeywordData"
                :key="item.hot_keyword_ID"
              >
              <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                #{{ item.hot_keyword_name }}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div class="hp_reservationWrap">
        <h4>
          바로결제
          <p>아래 정보를 정확히 입력해 주세요.</p>
        </h4>

        <div class="hp_reservationBox">
          <div class="hp_reservationBoxTit">
            <h5>예약자정보</h5>
            <div><span class="pointTextRed">*</span> 필수항목</div>
          </div>
          <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="예약자정보">
            <caption>예약자정보</caption>
            <colgroup>
              <col width="25%">
              <col width="*">
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <label for = 'reservation_customer_name'>예약자명 <span class="pointTextRed">*</span></label>
                </th>
                <td>
                  <input
                    type="text"
                    class="hp_reservBox_input"
                    id = 'reservation_customer_name'
                    v-model="formData.reservationCustomerName"
                    maxlength="10"
                  >
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for = 'reservation_customer_phone_number'>휴대전화 <span class="pointTextRed">*</span></label>
                </th>
                <td>
                  <input
                    type = "text"
                    class="hp_reservBox_input"
                    id = 'reservation_customer_phone_number'
                    v-model="formData.reservationCustomerPhoneNumber"
                    maxlength="13"
                  >
                </td>
              </tr>
              <tr>
                <th>
                  <label for = 'reservation_customer_phone_number2'>비상연락처</label>
                </th>
                <td>
                  <input
                    type = "text"
                    class="hp_reservBox_input"
                    id = 'reservation_customer_phone_number2'
                    v-model="formData.reservationCustomerPhoneNumber2"
                    maxlength="13"
                  >
                </td>
              </tr>
              <tr>
                <th>
                  <label for = 'reservation_customer_email'>이메일</label>
                </th>
                <td>
                  <input
                    type = "text"
                    class="hp_reservBox_input"
                    id = 'reservation_customer_email'
                    v-model="formData.reservationCustomerEmail"
                    maxlength="50"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="hp_reservationBox"> <!-- 다섯번째 : 결제정보 -->
          <div class="hp_reservationBoxTit">
            <h5>결제정보</h5>
          </div>
          <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="결제정보">
            <caption>결제정보</caption>
            <colgroup>
              <col width="27%">
              <col width="*">
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">결제방식</th>
                <td>
                  <div class="hp_paymentSelectBox">
                    <select v-model="formData.reservationPaymentMethod" aria-placeholder="결제방식을 선택하세요.">
                      <option value="" disabled selected>결제방식을 선택해주세요.</option>
                      <option value="0">무통장 입금</option>
                      <option value="1">신용카드</option>
                    </select>
                    <div v-if="formData.reservationPaymentMethod === '0'">
                      <div class="hp_paymentBankCopy" @click="copyToClipboard">
                        입금계좌안내
                        <p>{{ statusData.accountInfo }}</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="formData.reservationPaymentMethod === '0'">
                <th scope="row">입금자명</th>
                <td>
                  <input class = "hp_reservBox_input" type="text" id="reservation_depositor_name" v-model="formData.reservationDepositorName" placeholder="입금자명을 입력하세요">
                  <span class="hp_reservCheckbox">
                    <input type="checkbox" id="sameAsReserver" v-model="statusData.sameAsReserver" @change="copyReserverInfo">
                    <label for="sameAsReserver"><span></span>예약자와 동일</label>
                  </span>
                  <span class="hp_reservCheckbox">
                    <input type="checkbox" id="reservation_cash_receipt_request" v-model="formData.reservationCashReceiptRequest">
                    <label for="reservation_cash_receipt_request"><span></span>현금영수증 요청</label>
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">남기실 말씀</th>
                <td>
                  <textarea
                    id = 'reservation_customer_name'
                    v-model="formData.reservationRequest"
                    :maxlength="500"
                    placeholder="남기실 말씀을 입력해주세요 (최대 500자)"
                    cols="120"
                    rows="6"
                    class="hp_reservTextarea">
                  </textarea>
                  <p class="hp_reservTextareaNum">{{ formData.reservationRequest.length }}/500</p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="hp_optionBox_totalPrePrice" style="margin-top:30px;">
            <span>결제 금액 : </span>
            <span>
              {{this.formData.reservationPaymentAmount}}
            </span>원
          </div>
        </div>

        <div class="hp_commuDetail_privacyBox"> <!-- 댓글 작성 약관 동의 -->
          <div class="hp_commuDetail_pbAll">
            <input  type="checkbox" id="agreeAll" v-model="formData.agreeAll" @change="toggleAllAgreements" />
            <label for="agreeAll">이용약관 및 개인정보방침에 모두 동의합니다.</label>
          </div>
          <div class="hp_commuDetail_pbEarch">
            <div>
              <input type="checkbox" id="agree4" v-model="formData.agree4" @change="checkIndividualAgreements" />
              <label for="agree4"><span>[필수]</span> 서비스 이용약관에 동의</label>
            </div>
            <button type="button" @click="togglePopup(4)">약관보기</button>
          </div>
          <div class="hp_commuDetail_pbEarch">
            <div>
              <input type="checkbox" id="agree1" v-model="formData.agree1" @change="checkIndividualAgreements" />
              <label for="agree1"><span>[필수]</span> 수집하는 개인정보의 항목에 동의</label>
            </div>
            <button type="button" @click="togglePopup(1)">약관보기</button>
          </div>
          <div class="hp_commuDetail_pbEarch">
            <div>
              <input type="checkbox" id="agree2" v-model="formData.agree2" @change="checkIndividualAgreements" />
              <label for="agree2"><span>[필수]</span> 개인정보의 수집 이용목적에 동의</label>
            </div>
            <button type="button" @click="togglePopup(2)">약관보기</button>
          </div>
          <div class="hp_commuDetail_pbEarch">
            <div>
              <input type="checkbox" id="agree3" v-model="formData.agree3" @change="checkIndividualAgreements" />
              <label for="agree3"><span>[필수]</span> 개인정보의 보유 및 이용기간에 동의</label>
            </div>
            <button type="button" @click="togglePopup(3)">약관보기</button>
          </div>
        </div>

        <!-- 모바일용 예약하기 버튼 : 클릭 시 예약 완료 페이지로 이동함 -->
        <div class="hp_reservation_btnReservMob">
          <button @click="handleReservation">예약하기</button>
        </div>
        <!-- PC용 에약하기, 취소하기 버튼 -->  <!-- 반응형할때 조절하기! -->
        <div class="hp_reservation_btnReservPc">
          <button class="hp_reservation_btnReservPc_on" @click="handleReservation">예약하기</button>
          <button>취소하기</button>
        </div>
      </div>
    </div>
    <PopupComponent
      :isVisible="statusData.isPopupVisible"
      :toggleStatus="statusData.toggleStatus"
      @update:isVisible="statusData.isPopupVisible = $event"
    />
    <Footer/>
  </div>
</template>

<!-- eslint-disable camelcase -->
<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import Spiner from '../Section/Spiner.vue'
import PopupComponent from '../Section/PopupComponent.vue'
import { ref } from 'vue'
import {
  get_hot_keyword_top10,
  base_url_export,
  inicis_export,
  buildStatus,
  insert_reservation_immediate
} from '../../ETC/Axios.vue'
import {
  removeWhitespacePhone,
  removeWhitespaceStandardPhone
} from '../../ETC/Validation.vue'

export default {
  name: 'ReservationImmediate',
  components: {
    Header,
    Footer,
    Scroll,
    Spiner,
    PopupComponent
  },
  setup () {
    return {
      sessionData: ref({
        customer: ''
      }),
      statusData: ref({
        spinnerStatus: false,
        hotKeywordData: [],
        accountInfo: '(주)행복을주는사람들 / 우리은행 1005-303-875864',
        isSameAsReserver: false,
        sameAsReserver: false,
        toggleStatus: 1,
        isPopupVisible: false
      }),
      formData: ref({
        reservationCustomerName: '',
        reservationCustomerPhoneNumber: '',
        reservationCustomerPhoneNumber2: '',
        reservationCustomerEmail: '',
        reservationPaymentAmount: '',
        reservationPaymentMethod: '',
        reservationDepositorName: '',
        reservationCashReceiptRequest: false,
        reservationRequest: '',
        agreeAll: false,
        agree4: false,
        agree1: false,
        agree2: false,
        agree3: false
      })
    }
  },
  methods: {
    copyToClipboard () {
      if (this.formData.reservationPaymentMethod === '0') {
        const textarea = document.createElement('textarea')
        textarea.textContent = this.statusData.accountInfo
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        textarea.remove()
        alert('클립보드에 복사되었습니다.')
      }
    },
    copyReserverInfo () {
      if (this.statusData.sameAsReserver) {
        this.formData.reservationDepositorName = this.formData.reservationCustomerName
      } else {
        this.formData.reservationDepositorName = ''
      }
    },
    togglePopup (toggleStatus) {
      this.statusData.toggleStatus = toggleStatus
      this.statusData.isPopupVisible = !this.statusData.isPopupVisible
    },
    toggleAllAgreements () {
      this.formData.agree1 = this.formData.agreeAll
      this.formData.agree2 = this.formData.agreeAll
      this.formData.agree3 = this.formData.agreeAll
      this.formData.agree4 = this.formData.agreeAll
    },
    checkIndividualAgreements () {
      if (this.formData.agree1 && this.formData.agree2 && this.formData.agree3 && this.formData.agree4) {
        this.formData.agreeAll = true
      } else {
        this.formData.agreeAll = false
      }
    },
    handleReservation () {
      if (!this.formData.reservationCustomerName) {
        alert('예약자명을 입력해주세요.')
        return
      }
      if (!this.formData.reservationCustomerPhoneNumber) {
        alert('휴대전화를 입력해주세요.')
        return
      }
      if (this.formData.reservationPaymentMethod === '' && !this.formData.reservationDepositorName) {
        alert('결제방식을 선택해주세요.')
        return
      }
      if (this.formData.reservationPaymentMethod === '0' && !this.formData.reservationDepositorName) {
        alert('입금자명을 입력해주세요.')
        return
      }
      if (!this.formData.agree4 || !this.formData.agree1 || !this.formData.agree2 || !this.formData.agree3) {
        alert('모든 약관에 동의해주세요.')
        return
      }
      const processReservation = (imp_uid = '', merchant_uid = '') => {
        insert_reservation_immediate(
          this.formData.reservationCustomerName,
          this.formData.reservationCustomerPhoneNumber,
          this.formData.reservationCustomerPhoneNumber2,
          this.formData.reservationCustomerEmail,
          this.formData.reservationPaymentAmount.replace(/,/g, ''),
          this.formData.reservationPaymentMethod,
          this.formData.reservationDepositorName,
          this.formData.reservationCashReceiptRequest,
          this.formData.reservationRequest,
          this.formData.agree4,
          this.formData.agree1,
          this.formData.agree2,
          imp_uid,
          merchant_uid
        ).then((result) => {
          if (result.status === 'success') {
            if (this.formData.reservationPaymentMethod === '1') {
              alert('결제가 완료되었습니다.')
              this.$router.push({
                path: '/ReservationSuccessImmediate',
                query: {
                  reservation_payment_method: this.formData.reservationPaymentMethod,
                  reservation_ID: result.reservation_ID
                }
              })
            } else {
              alert('무통장 입금요청이 완료되었습니다.')
              this.$router.push({
                path: '/ReservationSuccessImmediate',
                query: {
                  reservation_payment_method: this.formData.reservationPaymentMethod,
                  reservation_ID: result.reservation_ID
                }
              })
            }
          }
        })
      }
      if (this.formData.reservationPaymentMethod === '1') {
        const reservationData = {
          reservation_customer_name: this.formData.reservationCustomerName,
          reservation_customer_phone_number: this.formData.reservationCustomerPhoneNumber,
          reservation_customer_phone_number_2: this.formData.reservationCustomerPhoneNumber2,
          reservation_customer_email: this.formData.reservationCustomerEmail,
          reservation_payment_amount: this.formData.reservationPaymentAmount.replace(/,/g, ''),
          reservation_payment_method: this.formData.reservationPaymentMethod,
          reservation_depositor_name: this.formData.reservationDepositorName,
          reservation_cash_receipt_request: this.formData.reservationCashReceiptRequest,
          reservation_request: this.formData.reservationRequest,
          reservation_terms_of_use: this.formData.agree4,
          reservation_privacy_statement: this.formData.agree1,
          reservation_electronic_terms_and_conditions: this.formData.agree2
        }
        const queryParams = new URLSearchParams(reservationData).toString()
        const IMP = window.IMP
        const paymentData = {
          pg: inicis_export,
          pay_method: 'card',
          merchant_uid: `mid_${new Date().getTime()}`,
          name: `${this.formData.reservationCustomerName} 고객님 결제`,
          amount: buildStatus === 'test' ? 1000 : this.formData.reservationPaymentAmount.replace(/,/g, ''),
          buyer_name: this.formData.reservationCustomerName,
          buyer_tel: this.formData.reservationCustomerPhoneNumber,
          buyer_email: this.formData.reservationCustomerEmail,
          buyer_addr: '',
          m_redirect_url: `${base_url_export}reservation/mobile_insert_reservation_immediate?${queryParams}`
        }
        IMP.request_pay(paymentData, (response) => {
          // 테스트 시 !response.success로 진행
          if (response.success) {
            processReservation(response.imp_uid, response.merchant_uid)
          } else {
            alert(`결제 실패: ${response.error_msg}`)
          }
        })
      } else {
        processReservation()
      }
    }
  },
  watch: {
    'formData.reservationCustomerName': function (value) {
      if (this.statusData.isSameAsReserver && this.formData.reservationSeatArray.length > 0) {
        this.formData.reservationSeatArray[0].reservation_seat_customer_name = value
      }
    },
    'formData.reservationCustomerPhoneNumber': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.reservationCustomerPhoneNumber = removeWhitespacePhone(cleanValue)
      if (this.statusData.isSameAsReserver && this.formData.reservationSeatArray.length > 0) {
        this.formData.reservationSeatArray[0].reservation_seat_customer_phone_number = removeWhitespaceStandardPhone(cleanValue)
      }
    },
    'formData.reservationCustomerPhoneNumber2': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.reservationCustomerPhoneNumber2 = removeWhitespaceStandardPhone(cleanValue)
    }
  },
  mounted () {
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    if (this.$route.query.name !== undefined) {
      this.formData.reservationCustomerName = this.$route.query.name
      this.formData.reservationCustomerPhoneNumber = this.$route.query.phone
      this.formData.reservationCustomerEmail = this.$route.query.email
      this.formData.reservationPaymentAmount = this.$route.query.amount
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Reservation/ReservationImmediate.vue